import {
	checkHasServerError,
	clearError,
	emailValidator,
	isEqualText,
	isSameFioForIp,
	isValidCharacters,
	isValidPasswordValidator,
	searchText,
	validate14yearsPassportInterval,
	validateAccountNumber,
	validateActiveLead,
	validateAge,
	validateBIK,
	validateByRegex,
	validateCodeIkz,
	validateCommission,
	validateCyrillicName,
	validateCyrillicsWithHyphen,
	validateFloatNumber,
	validateHouseAddress,
	validateIfDateExistInPayload,
	validateIfNumberExists,
	validateIfValueIsTrue,
	validateInn,
	validateIpAddress,
	validateIsEqualPassword,
	validateKbk,
	validateKPP,
	validateLatinicName,
	validateLength,
	validateLessDate,
	validateLessMoreDate,
	validateLessMoreEqualsDate,
	validateLotNumber,
	validateMaxLength,
	validateMaxLengthWithoutLink,
	validateMomentDate,
	validateMoreDate,
	validateNumber,
	validateOgrn,
	validateOkato,
	validateOKFS,
	validateOKOPF,
	validateOkpo,
	validateOktmo,
	validateOkvedCodes,
	validateOkveds,
	validatePassportCode,
	validatePassportIssueDate,
	validatePassportNumber,
	validatePassportSeries,
	validatePassportString,
	validatePaymentAccount,
	validatePhone,
	validatePhoneWithMask,
	validatePositiveNumber,
	validatePOSName,
	validatePurchaseCode,
	validateSelectBIK,
	validateSizeVideo,
	validateSnils,
	validateStartDateMoreThanMaxHour,
	validateUrl,
	validateUrlWithHttp,
	ValidatorFactory,
	validateMustHaveQuote,
	validateQuotesOrgName,
	validateCyrillicOrLatinQuotes,
	validateMinMaxAge,
	validatePasswordGivenBy,
} from 'Modules'

export const Validators = {
	reduxFormValidator: ValidatorFactory.createReduxValidator(),
	checkEmail: ValidatorFactory.createValidator(emailValidator),
	checkPhone: ValidatorFactory.createValidator(validatePhone),
	checkPhoneWithMask: ValidatorFactory.createValidator(validatePhoneWithMask),
	checkPositiveNumber: ValidatorFactory.createValidator(validatePositiveNumber),
	checkCyrillicName: ValidatorFactory.createValidator(validateCyrillicName),
	checkLatinicName: ValidatorFactory.createValidator(validateLatinicName),
	checkPOSName: ValidatorFactory.createValidator(validatePOSName),
	checkOkvedCodes: ValidatorFactory.createValidator(validateOkvedCodes),
	checkInn: ValidatorFactory.createValidator(validateInn),
	checkSnils: ValidatorFactory.createValidator(validateSnils),
	checkAccountNumber: ValidatorFactory.createValidator(validateAccountNumber),
	checkBIK: ValidatorFactory.createValidator(validateBIK),
	checkSelectBIK: ValidatorFactory.createValidator(validateSelectBIK),
	checkKPP: ValidatorFactory.createValidator(validateKPP),
	checkOKOPF: ValidatorFactory.createValidator(validateOKOPF),
	checkOKFS: ValidatorFactory.createValidator(validateOKFS),
	checkPaymentAccount: ValidatorFactory.createValidator(validatePaymentAccount),
	checkOktmo: ValidatorFactory.createValidator(validateOktmo),
	checkKBK: ValidatorFactory.createValidator(validateKbk),
	checkRequired: ValidatorFactory.createValidator(),
	checkIfDateExistInPayload: ValidatorFactory.createValidator(validateIfDateExistInPayload),
	checkCyrillicsWithHyphen: ValidatorFactory.createValidator(validateCyrillicsWithHyphen),
	checkIpAddress: ValidatorFactory.createValidator(validateIpAddress),
	checkNumber: ValidatorFactory.createValidator(validateNumber),
	checkFloatNumber: ValidatorFactory.createValidator(validateFloatNumber),
	checkLessDate: ValidatorFactory.createValidator(validateLessDate),
	checkMoreDate: ValidatorFactory.createValidator(validateMoreDate),
	checkLessMoreDate: ValidatorFactory.createValidator(validateLessMoreDate),
	checkMomentDate: ValidatorFactory.createValidator(validateMomentDate),
	checkMaxLength: ValidatorFactory.createValidator(validateMaxLength),
	checkSearchText: ValidatorFactory.createValidator(searchText),
	clearError: ValidatorFactory.createValidator(clearError),
	checkAge: ValidatorFactory.createValidator(validateAge),
	checkMinMaxAge: ValidatorFactory.createValidator(validateMinMaxAge),
	check14yearsPassportInterval: ValidatorFactory.createValidator(validate14yearsPassportInterval),
	checkPassportIssueDate: ValidatorFactory.createValidator(validatePassportIssueDate),
	checkPurchaseCode: ValidatorFactory.createValidator(validatePurchaseCode),
	checkOGRN: ValidatorFactory.createValidator(validateOgrn),
	checkOkato: ValidatorFactory.createValidator(validateOkato),
	checkOkpo: ValidatorFactory.createValidator(validateOkpo),
	checkSizeVideo: ValidatorFactory.createValidator(validateSizeVideo),
	checkPassportSeries: ValidatorFactory.createValidator(validatePassportSeries),
	checkPassportNumber: ValidatorFactory.createValidator(validatePassportNumber),
	checkOkveds: ValidatorFactory.createValidator(validateOkveds),
	checkIfNumberExists: ValidatorFactory.createValidator(validateIfNumberExists),
	checkPassportCode: ValidatorFactory.createValidator(validatePassportCode),
	checkPassportString: ValidatorFactory.createValidator(validatePassportString),
	checkPasswordISEquial: ValidatorFactory.createValidator(validateIsEqualPassword),
	checkUrl: ValidatorFactory.createValidator(validateUrl),
	checkTrueValue: ValidatorFactory.createValidator(validateIfValueIsTrue),
	checkUrlWithHttp: ValidatorFactory.createValidator(validateUrlWithHttp),
	checkStartDateMoreThanMaxHour: ValidatorFactory.createValidator(validateStartDateMoreThanMaxHour),
	checkCodeIkz: ValidatorFactory.createValidator(validateCodeIkz),
	checkLength: ValidatorFactory.createValidator(validateLength),
	checkByRegex: ValidatorFactory.createValidator(validateByRegex),
	checkIsEqualText: ValidatorFactory.createValidator(isEqualText),
	checkIsSameFioForIp: ValidatorFactory.createValidator(isSameFioForIp),
	checkIsLotNumber: ValidatorFactory.createValidator(validateLotNumber),
	checkPassword: ValidatorFactory.createValidator(validateIsEqualPassword),
	checkIsValidPassword: ValidatorFactory.createValidator(isValidPasswordValidator),
	checkInvalidCharacters: ValidatorFactory.createValidator(isValidCharacters),
	checkMaxLengthWithoutLink: ValidatorFactory.createValidator(validateMaxLengthWithoutLink),
	checkHasServerError: ValidatorFactory.createValidator(checkHasServerError),
	checkLessMoreEqualsDate: ValidatorFactory.createValidator(validateLessMoreEqualsDate),
	checkHasHouseAddress: ValidatorFactory.createValidator(validateHouseAddress),
	checkCommissionReject: ValidatorFactory.createValidator(validateCommission),
	checkActiveLead: ValidatorFactory.createValidator(validateActiveLead),
	checkMustUseQuote: ValidatorFactory.createValidator(validateMustHaveQuote),
	checkQuotesOrgName: ValidatorFactory.createValidator(validateQuotesOrgName),
	checkCyrillicOrLatinQuotes: ValidatorFactory.createValidator(validateCyrillicOrLatinQuotes),
	validatePassportGivenBy: ValidatorFactory.createValidator(validatePasswordGivenBy),
}
